<template>
	<div :id="globeId" class="globe"></div>
</template>

<script setup lang="ts">
	import { onMounted, ref, watch } from 'vue'
	import GlobeDestinationActions from '~/actions/home/globeDestination'
	import { LocationData } from '~/models/Destination'
	import { ProfileDestination } from '~/models/ProfileDestination'
	import { GlobeService } from '~/services/globe/service'

	interface Props {
		wishlist: ProfileDestination[]
		visited: ProfileDestination[]
		center: LocationData
		isXS: boolean
	}
	const props = defineProps<Props>()
	const emit = defineEmits(['select'])

	const globeId: string = 'globe'
	const map = ref<GlobeService>()

	onMounted(async () => {
		let zoom = 2
		if (props.isXS) zoom = 1
		map.value = await GlobeDestinationActions.initialize(globeId, props.center, zoom)
		map.value.onCountryClick(openDestination)
		GlobeDestinationActions.printDestinations(props.wishlist, props.visited, map.value!)
	})

	watch([() => props.wishlist, () => props.visited], () => {
		if (!map.value) return
		GlobeDestinationActions.printDestinations(props.wishlist, props.visited, map.value)
	})

	const openDestination = (iso: string) => {
		const normalized = GlobeDestinationActions.normalizeIso(iso)
		emit('select', normalized)
	}

	const deselectCountry = () => {
		map.value?.deselectCountry()
	}

	defineExpose({ deselectCountry })
</script>

<style lang="scss" scoped>
	.globe {
		height: 100vh;
		overflow: hidden;
	}
</style>

<style lang="scss">
	.mapboxgl-control-container {
		position: absolute;
		bottom: 0;
		right: 0;
		font-size: 14px;

		.mapboxgl-ctrl-attrib-inner {
			padding: 0.25rem;
			background-color: #ffffff66;
		}

		a:hover {
			text-decoration: underline;
		}

		.mapbox-improve-map {
			display: none;
		}
	}
</style>
